export interface IUser {
  firstName: string;
  lastName: string;
  emailId: string;
  picture?: string;
  kycStatus?: boolean;
}

export interface IDBUser {
  __typename: string;
  createdat: string | null;
  id: string;
  emailid: string;
  tenantid: string;
  tenantuserid: string;
  role: string | null;
}
export enum UserRoleEnum {
  READ_AND_WRITE_ADMIN = 'READ_AND_WRITE_ADMIN',
  READ_ONLY_ADMIN = 'READ_ONLY_ADMIN',
}
